import { gyymPrefetch, withGyymISR } from '@gyym/sdk-next'
import React from 'react'

import { SingleColumnLayout } from '@/components/Layouts/legacy/SingleColumnLayout'
import { FacilityListView } from '@/components/Views/FacilityListView'
import { buildOgImageUrl } from '@/lib/ogiGenerator'
import { useRecommendedFacilities } from '@/modules/Facilities'

export const getStaticProps = withGyymISR(
  async (_ctx, client) => [
    gyymPrefetch(client.user.facilities.listRecommended),
  ],
  {
    // 3 minutes
    revalidate: 60 * 3,
  },
)

const ogImageUrl = buildOgImageUrl`**スタッフおすすめ**
施設一覧`

const RecommendedIndex = () => {
  const { facilities } = useRecommendedFacilities()

  return (
    <SingleColumnLayout
      title="スタッフおすすめの施設一覧 | GYYM (都度利用サービス)"
      description="スタッフおすすめの施設一覧ページです。利用料金は利用した分だけ！ジム初心者やしっかり体験したい方も安心の入会金無料・ビジターOKの都度利用型のジムネットワークサービス | 1チケットフィットネス GYYM"
      keywords={[
        'gyym',
        'GYYM',
        'ジム',
        'フィットネス',
        'スタジオ',
        'ジム 都度利用',
        'ジム 体験',
        'ジム 入会金無料',
        'ジム 初心者',
      ]}
      ogImageUrl={ogImageUrl}
      heading="スタッフおすすめの施設"
      breadcrumbs={[
        { label: 'TOP', href: '/' },
        { label: 'スタッフおすすめの施設', href: '/recommended' },
      ]}
    >
      <FacilityListView facilities={facilities} />
    </SingleColumnLayout>
  )
}

export default RecommendedIndex
